import * as React from 'react'
import { useSearchParams } from 'react-router-dom'
import { Checkbox } from "@mui/material";

type TMapStateToProps = {
    name: string,
    field_name: string
}

export const CustomCheckbox = ({ name, field_name }: TMapStateToProps) => {
    const [searchParams, setSearchParams] = useSearchParams();

    return (
        <div><Checkbox sx={{ padding: "3px", fontSize: "13px" }} checked={searchParams.has(field_name)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => event.target.checked ? setSearchParams({...Object.fromEntries([...searchParams]), [field_name]: 1, 'page': "1"}  as unknown as URLSearchParams) : setSearchParams({...Object.fromEntries([...searchParams]), [field_name]: []})}/><span style={{ fontSize: "13px" }}>{name}</span></div>
    )
}